import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
function ImacFrame({
  image,
  title,
  url
}: {
  image: string;
  title: string;
  url: string;
}) {
  const displayUrl = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  return <div className="flex flex-col items-center" data-id="element-86">
      {/* iMac Body */}
      <div className="w-full rounded-xl overflow-hidden border border-white/10 bg-[#1a1a1a] shadow-2xl group-hover:shadow-[0_20px_60px_rgba(212,175,55,0.15)] transition-shadow duration-500" data-id="element-87">
        {/* Top Bar - macOS style */}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#2a2a2a] border-b border-white/5" data-id="element-88">
          <div className="flex items-center gap-1.5" data-id="element-89">
            <div className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" data-id="element-90" />
            <div className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" data-id="element-91" />
            <div className="w-2.5 h-2.5 rounded-full bg-[#28c840]" data-id="element-92" />
          </div>
          <div className="flex-1 mx-4" data-id="element-93">
            <div className="bg-[#1a1a1a] rounded-md px-3 py-1 text-[10px] text-gray-500 text-center truncate font-mono" data-id="element-94">
              {displayUrl}
            </div>
          </div>
        </div>

        {/* Screen */}
        <div className="relative overflow-hidden aspect-[16/10] bg-black" data-id="element-95">
          <img src={image} alt={`${title} website preview`} loading="lazy" className="w-full h-auto object-cover object-top absolute top-0 left-0 transition-transform duration-[4000ms] ease-in-out group-hover:-translate-y-[60%]" data-id="element-96" />
          {/* Subtle overlay */}
          <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-97" />

          {/* Hover visit icon */}
          <div className="absolute inset-0 flex items-center justify-center z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-98">
            <div className="w-12 h-12 rounded-full bg-black/60 backdrop-blur-md flex items-center justify-center border border-white/20 shadow-lg" data-id="element-99">
              <ExternalLinkIcon className="w-5 h-5 text-white" data-id="element-100" />
            </div>
          </div>
        </div>
      </div>

      {/* iMac Stand */}
      <div className="relative flex flex-col items-center" data-id="element-101">
        <div className="w-16 h-6 bg-gradient-to-b from-[#c0c0c0] to-[#a0a0a0] rounded-b-sm" style={{
        clipPath: 'polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)'
      }} data-id="element-102" />
        <div className="w-24 h-1.5 bg-gradient-to-b from-[#b0b0b0] to-[#909090] rounded-full -mt-px" data-id="element-103" />
      </div>
    </div>;
}
export function PortfolioSection() {
  const industries = ['Beauty', 'Health & Fitness', 'Home & Living', 'Wellness', 'Food & Beverage'];
  const portfolioItems = [{
    title: 'Mama Said',
    category: 'Natural Skincare',
    url: 'https://mamasaid.shop/',
    image: 'https://cdn.magicpatterns.com/uploads/gge3zN3o5yhdVPojCK8gy1/screencapture-mamasaid-shop-2026-03-17-02_13_46.png'
  }, {
    title: 'Raptor Gym',
    category: 'Health & Fitness',
    url: 'https://www.raptorgym.co.uk/',
    image: 'https://cdn.magicpatterns.com/uploads/ikbA1fqtaom6LKDzA2LgpA/screencapture-raptorgym-co-uk-2026-03-17-02_14_32.png'
  }, {
    title: 'Satin Gel',
    category: 'Personal Wellness',
    url: 'https://satingel.com/',
    image: 'https://cdn.magicpatterns.com/uploads/ds7DHKaHoPCS354XeKHhma/screencapture-satingel-2026-03-17-02_17_21.png'
  }, {
    title: 'Palmpring USA',
    category: 'Home & Living',
    url: 'https://palmpringusa.com/',
    image: 'https://cdn.magicpatterns.com/uploads/54xdsG51LqKkCannc3hvSD/screencapture-palmpringusa-2026-03-17-02_16_18.png'
  }, {
    title: 'Twig Story',
    category: 'Handcrafted Home Decor',
    url: 'https://twigstory.com/',
    image: 'https://cdn.magicpatterns.com/uploads/qJygmKeABjHLSmYCsKfSX6/screencapture-twigstory-2026-03-17-20_41_11_(1).png'
  }, {
    title: 'Mawka Drink',
    category: 'Food & Beverage',
    url: 'https://mawkadrink.com/',
    image: 'https://cdn.magicpatterns.com/uploads/g1QDmrVN1X9UdEsGoqGqa3/screencapture-mawkadrink-2026-03-17-20_51_34.png'
  }];
  return <section className="section-padding relative" data-id="element-104">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16" data-id="element-105">
        <div className="max-w-2xl" data-id="element-106">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-107">Our Work</h2>
          <p className="text-xl text-gray-400" data-id="element-108">
            We build custom Shopify stores, high-end product pages, and advanced
            checkout flows across multiple industries.
          </p>
        </div>
        <Link to="/portfolio" className="inline-flex items-center gap-2 text-gradient-gold font-semibold hover:opacity-80 transition-opacity whitespace-nowrap group" data-id="element-109">
          View Full Portfolio{' '}
          <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-110" />
        </Link>
      </div>

      <div className="flex flex-wrap gap-3 mb-12" data-id="element-111">
        {industries.map((industry, index) => <span key={index} className="px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm text-gray-300 hover:border-[#D4AF37]/50 hover:text-white transition-colors cursor-default" data-id="element-112">
            {industry}
          </span>)}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-113">
        {portfolioItems.slice(0, 6).map((item, index) => <a key={index} href={item.url} target="_blank" rel="noopener noreferrer" className="group block" data-id="element-114">
            <ImacFrame image={item.image} title={item.title} url={item.url} data-id="element-115" />
            <div className="text-center mt-5" data-id="element-116">
              <p className="text-[#D4AF37] text-xs font-bold uppercase tracking-wider mb-2" data-id="element-117">
                {item.category}
              </p>
              <h3 className="text-2xl font-bold text-white group-hover:text-[#D4AF37] transition-colors" data-id="element-118">
                {item.title}
              </h3>
            </div>
          </a>)}
      </div>

      <div className="text-center mt-12" data-id="element-119">
        <Link to="/portfolio" className="inline-flex items-center justify-center gap-2 bg-gradient-gold text-black px-8 py-3.5 rounded-full font-semibold text-base gold-glow-hover transition-all duration-300 hover:scale-105 group" data-id="element-120">
          View All Projects
          <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-121" />
        </Link>
      </div>
    </section>;
}